import { z } from 'zod';

export const NoEjecutadoBodySchema = z.object({
  cncCodigoId: z.number().int().positive({ message: 'Debe seleccionar un codigo CNC' }),
  observaciones: z.string().max(2000).optional(),
  reason: z.string().max(500).optional(),
});

export type NoEjecutadoBody = z.infer<typeof NoEjecutadoBodySchema>;
